export const BATCH_PLANNING_MAX_ROWS = 10_000
export const DEMO_BATCH_PLANNING_MAX_PROPERTIES = 10
export const DEMO_BATCH_PLANNING_LIMIT_MESSAGE =
  "Im Demozugang können maximal 10 Liegenschaften gleichzeitig gesammelt geplant werden. Wohneinheiten innerhalb dieser Liegenschaften sind unbegrenzt."

export type DemoBatchPlanningLimitContext = {
  trialRestrictionsActive?: boolean | null
}

export const demoBatchPlanningPropertyLimit = (
  context: DemoBatchPlanningLimitContext = {},
): number | null => (context.trialRestrictionsActive ? DEMO_BATCH_PLANNING_MAX_PROPERTIES : null)

export const batchPlanningRowLimit = (): number => BATCH_PLANNING_MAX_ROWS

export const validateBatchPlanningRowLimit = (rowCount: number): string | null => {
  const limit = batchPlanningRowLimit()

  if (rowCount <= limit) return null

  return `Maximal ${BATCH_PLANNING_MAX_ROWS.toLocaleString("de-DE")} Aufträge können auf einmal geplant werden.`
}

export const validateDemoBatchPlanningPropertyLimit = (
  propertyCount: number,
  context: DemoBatchPlanningLimitContext = {},
): string | null => {
  const limit = demoBatchPlanningPropertyLimit(context)

  if (!limit || propertyCount <= limit) return null

  return DEMO_BATCH_PLANNING_LIMIT_MESSAGE
}

export const uniquePropertyIdsForWorkOrders = (
  workOrders: Array<{ property_id?: string | null } | null | undefined>,
): string[] =>
  Array.from(
    new Set(
      workOrders.map((workOrder) => `${workOrder?.property_id ?? ""}`.trim()).filter(Boolean),
    ),
  )

export const uniquePropertyCountForWorkOrders = (
  workOrders: Array<{ property_id?: string | null } | null | undefined>,
): number => uniquePropertyIdsForWorkOrders(workOrders).length
